import {UserManager, WebStorageStateStore, Log} from 'oidc-client';
import {Constants} from '../helpers/constants';

export default class AuthService {
  UserManager;

  constructor() {
    const settings = {
      automaticSilentRenew: true,
      authority: Constants.stsAuthority,
      client_id: Constants.clientId,
      redirect_uri: Constants.redirect_uri, // /signin-oidc
      post_logout_redirect_uri: Constants.post_logout_redirect_uri,
      response_type: 'code',
      response_mode: 'query',
      scope: Constants.clientScope,
      silent_redirect_uri: Constants.silent_redirect_uri,
      // loadUserInfo: false,
      userStore: new WebStorageStateStore({store: window.sessionStorage}),
    };

    this.UserManager = new UserManager({
      ...settings,
      userStore: new WebStorageStateStore({store: window.sessionStorage}),
    });

    Log.logger = console;
    Log.level = Log.INFO;

    this.UserManager.events.addUserLoaded((user) => {
      if (window.location.href.indexOf('signin-oidc') !== -1) {
        this.navigateToScreen();
      }
    });

    this.UserManager.events.addSilentRenewError((e) => {});

    this.UserManager.events.addAccessTokenExpired(() => {
      localStorage.clear();
      this.UserManager.clearStaleState();
      this.signinRedirect();
    });
  }

  navigateToScreen = () => {
    window.location.replace('/');
  };

  signinSilent = () => {
    localStorage.setItem('redirectUri', window.location.origin);
    this.UserManager.signinSilent();
  };

  signinRedirectCallback = () => {
    this.UserManager.signinRedirectCallback().then((user) => {
      localStorage.setItem('user', JSON.stringify(user));
    });
  };

  getUser = async () => {
    const user = await this.UserManager.getUser();
    if (!user) {
      return await this.UserManager.signinRedirectCallback();
    }

    return user;
  };

  signinRedirect = () => {
    localStorage.setItem('redirectUri', window.location.pathname);
    this.UserManager.signinRedirect();
  };

  isAuthenticated = () => {
    const oidcStorage = JSON.parse(
      sessionStorage.getItem(
        `oidc.user:${process.env.REACT_APP_BASE_STSAUTHORITY}:${process.env.REACT_APP_BASE_WSO2_CLIENT_ID}`
      ) || '{}'
    );

    return !!oidcStorage && !!oidcStorage.access_token;
  };

  signinSilentCallback = () => {
    this.UserManager.signinSilentCallback();
  };

  createSigninRequest = () => {
    return this.UserManager.createSigninRequest();
  };

  logout = () => {
    const state = localStorage.getItem('BuId') || '';
    const redirectToRegister = localStorage.getItem('redirectToRegister');
    const userJson = localStorage.getItem('user');

    let id_token_hint = '';
    if (userJson) {
      try {
        const user = JSON.parse(userJson);
        id_token_hint = user.id_token || '';
      } catch (e) {
        console.error('Failed to parse user token', e);
      }
    }

    var stateParam: string;

    if (redirectToRegister !== null) {
      stateParam = Constants.clientId + redirectToRegister + state;
    } else {
      stateParam = Constants.clientId + state;
    }

    const queryParams: any = {
      id_token_hint: id_token_hint,
    };

    if (state) {
      queryParams.extraQueryParams = {
        state: stateParam,
      };
    }

    const redirectUrl = localStorage.getItem('redirectUrl');
    localStorage.clear();
    localStorage.setItem('redirectUrl', redirectUrl || '');
    sessionStorage.clear();
    this.UserManager.signoutRedirect(queryParams);
    this.UserManager.clearStaleState();
  };

  silentLogout = () => {
    //const history = useHistory();

    const state = localStorage.getItem('BuId');
    const queryParams = state
      ? {
          extraQueryParams: {
            state: state,
          },
        }
      : {};
    localStorage.clear();
    //this.UserManager.signoutRedirect(queryParams);
    this.UserManager.clearStaleState();
    //history.push('/registo');
  };
}
